import {Component, ViewEncapsulation} from '@angular/core';
import {CrudSavePopupComponent} from '../../_directives';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CampaignService} from '../../_services';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
  selector: 'app-campaign-general-edit-popup',
  templateUrl: './campaign-general-edit-popup.component.html',
  styleUrls: ['../campaign-section.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CampaignGeneralEditPopupComponent extends CrudSavePopupComponent {
  public isPartial = true;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected campaignService: CampaignService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder
  ) {
    super(router, location, route, campaignService, alertService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: [null, [Validators.required]]
    });
    super.ngOnInit();
  }

  protected getFormData(): any {
    let data = super.getFormData();
    data['display_name'] = data['name'];
    return data;
  }
}
